<script setup lang="ts">
  const props = defineProps({
    list: { type: Array<any>, required: true },
    title: { type: String, required: true },
    subTitle: { type: String, required: true }
  })
</script>
<template>
  <h1 v-text="props.title"></h1>
  <h3 class="d-none d-md-block u-mb-md-3" v-text="props.subTitle"></h3>
  <vue-collapsible-panel-group base-color="#2d2b3b">
    <vue-collapsible-panel v-for="(item, key) in props.list" :key="key" :expanded="false">
      <template #title>
        {{ item.title }}
      </template>
      <template #content>
      <p>{{ item.subtitle }}</p>
      </template>
    </vue-collapsible-panel>
  </vue-collapsible-panel-group>
</template>
<style lang="css" scoped>
  .vcpg {
    color: #000;
    border: none !important;
  }

  .vcpg :deep(.vcp__header) {
    border-radius: 35px;
    background-color: #f8f8f8 !important;
    margin-top: 10px;
    padding: 26px;
    border: 1px solid var(--border-color);
  }

  .vcpg :deep(.vcp__body) {
    border-top: none !important;
    height: auto;
  }

  .vcpg :deep(.vcp__header-title) {
    color: #000000;
    font-family: 'Roboto-Bold';
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
  }

  .vcpg :deep(.vcp__body-content h5) {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }

  .vcpg :deep(.vcp__body-content h3) {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }

  .vcpg :deep(.vcp__body-content p) {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }

  .vcpg :deep(.vcp__body-content span) {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }

  .vcpg :deep(.vcp__body-content li) {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }
</style>
